import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'

Vue.config.productionTip = true;

import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

export const bus = new Vue();

import { APIFriendsLocalization } from './js/api_friends_localization'
import router from './router'
APIFriendsLocalization.save();

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
